import { TENANT_GOVERNANCE_PERMISSION_GROUPS } from "../../constants/tenantGovernancePermissions";

export const TENANT_ADMIN_WORKFLOWS = [
  {
    key: "workflow_workorder",
    slug: "werkbon",
    title: "Werkbon workflow",
    description: "Statusstappen, afrondregels en typegedrag voor werkbonnen.",
    permissionsAny: [...TENANT_GOVERNANCE_PERMISSION_GROUPS.workflowsView, "workorders.plan"],
  },
  {
    key: "workflow_calculatie",
    slug: "calculatie",
    title: "Calculatie workflow",
    description: "Voorbereiding en validatiestappen voor calculaties.",
    permissionsAny: TENANT_GOVERNANCE_PERMISSION_GROUPS.workflowsView,
  },
  {
    key: "workflow_administratie",
    slug: "administratie",
    title: "Administratie workflow",
    description: "Instellingen rond facturatie, e-invoicing en afhandeling.",
    permissionsAny: [
      ...TENANT_GOVERNANCE_PERMISSION_GROUPS.workflowsView,
      "financial_control.manage",
      "integrations.settings",
    ],
  },
  {
    key: "workflow_inkoop",
    slug: "inkoop",
    title: "Inkoop workflow",
    description: "Goedkeuringsbeleid, limieten en procesregels voor inkoop.",
    permissionsAny: [
      ...TENANT_GOVERNANCE_PERMISSION_GROUPS.workflowsView,
      "workorder.finance.manage",
      "integrations.settings",
    ],
  },
  {
    key: "workflow_uren",
    slug: "uren-goedkeuring",
    title: "Uren & goedkeuring",
    description: "Regels voor urenregistratie, indiening en goedkeuring.",
    permissionsAny: [
      ...TENANT_GOVERNANCE_PERMISSION_GROUPS.workflowsView,
      "workorder.time.approve",
      "hourtypes.edit",
    ],
  },
  {
    key: "workflow_customer_portal",
    slug: "klantportaal",
    title: "Klantportaal workflow",
    description: "Publicatieregels en zichtbaarheid voor klantportaalprocessen.",
    permissionsAny: TENANT_GOVERNANCE_PERMISSION_GROUPS.workflowsView,
  },
  {
    key: "workflow_kam",
    slug: "kam-veiligheid",
    title: "KAM / Veiligheid",
    description: "Borging van veiligheids- en kwaliteitsworkflow binnen de tenant.",
    permissionsAny: [...TENANT_GOVERNANCE_PERMISSION_GROUPS.workflowsView, "kam.view", "kam.actions.manage"],
  },
  {
    key: "workflow_compliance",
    slug: "compliance-logboeken",
    title: "Compliance / logboeken",
    description: "Configuratie van compliance en digitale logboekstromen.",
    permissionsAny: [...TENANT_GOVERNANCE_PERMISSION_GROUPS.workflowsView, "projects.edit", "workorder.create"],
  },
];

export function getWorkflowDetailPath(slug) {
  return `/tenant-admin/workflows/${slug}`;
}

export function findWorkflowBySlug(slug) {
  const value = String(slug || "").trim().toLowerCase();
  return TENANT_ADMIN_WORKFLOWS.find((workflow) => workflow.slug === value) || null;
}
